import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M6.5 9.16927V7.33594C6.5 4.30177 7.41667 1.83594 12 1.83594C16.5833 1.83594 17.5 4.30177 17.5 7.33594V9.16927",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12.0007 16.9583C13.2663 16.9583 14.2923 15.9323 14.2923 14.6667C14.2923 13.401 13.2663 12.375 12.0007 12.375C10.735 12.375 9.70898 13.401 9.70898 14.6667C9.70898 15.9323 10.735 16.9583 12.0007 16.9583Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M16.584 20.1641H7.41732C3.75065 20.1641 2.83398 19.2474 2.83398 15.5807V13.7474C2.83398 10.0807 3.75065 9.16406 7.41732 9.16406H16.584C20.2507 9.16406 21.1673 10.0807 21.1673 13.7474V15.5807C21.1673 19.2474 20.2507 20.1641 16.584 20.1641Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }